$(document).ready(function () {
    console.log("Subscription Widget geladen");

    function formatMoney(amount) {
        // Zeige .00 nur wenn nötig, sonst .-
        if (amount % 1 === 0) {
            return Math.floor(amount) + ".-";
        } else {
            return new Intl.NumberFormat("de-CH", { style: "decimal", minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(amount);
        }
    }

    // Initialisiert Subscription-Optionen
    function initializeSubscriptionOptions() {
        $('#selling_plan_id').val('');
    }

    // Aktualisiert die Preise für Subscription & Bundle
    function updateSubscriptionPrice() {
        $('.product-subscription').each(function () {
            let productContainer = $(this);
            let productPrice = parseFloat(
                productContainer.find(".single-price").text().replace(".-", "").replace(",", ".")
            );

            if (isNaN(productPrice) || productPrice <= 0) return;

            let selectedRadio = productContainer.find('input[name="subscription"]:checked');
            let selectedOption = selectedRadio.val();

            // -------------------------
            // BUNDLE (scoped!)
            // -------------------------
            let priceContainer = selectedRadio
                .closest('.subscription-item-wrap')
                .find('.bundle-price');

            if (priceContainer.length) {

                // Normales Bundle (3x / 15%)
                if (selectedOption === 'bundle') {
                    priceContainer.find('.reg_price')
                        .text(formatMoney(productPrice * 3 * 0.85));
                    priceContainer.find('del')
                        .text(formatMoney(productPrice * 3));
                }

                // Four Pack (4x / 25%)
                if (selectedOption === 'bundle-new') {
                    priceContainer.find('.reg_price')
                        .text(formatMoney(productPrice * 4 * 0.75));
                    priceContainer.find('del')
                        .text(formatMoney(productPrice * 4));
                }
            }

            // -------------------------
            // SUBSCRIPTION (unverändert)
            // -------------------------
            let subscriptionPrice = productPrice * 0.85;
            productContainer.find(".subs-price .reg_price").text(formatMoney(subscriptionPrice));
            productContainer.find(".subs-price del").text(formatMoney(productPrice));
        });
    }

    // Aktualisiert die Menge je nach Subscription-Typ
    function updateCartQuantity() {
        $('.product-subscription').each(function () {
            let productContainer = $(this);
            let selectedOption = productContainer.find('input[name="subscription"]:checked').val();
            let quantityInput = $('.quantity__input');

            if (selectedOption === 'bundle') {
                quantityInput.removeAttr('disabled').val(3);
            } 
            else if (selectedOption === 'bundle-new') {
                quantityInput.removeAttr('disabled').val(4);
            } 
            else {
                quantityInput.attr('disabled', 'disabled').val(1);
            }
        });
    }

    // Setzt das `selling_plan_id` Feld korrekt
    function updateSellingPlanId() {
        $('.product-subscription').each(function () {
            let productContainer = $(this);
            let selectedOption = productContainer.find('input[name="subscription"]:checked').val();
            let oName = selectedOption;

            console.log('oName ' + oName);

            if (oName === 'subscription') {
                let sellingPlanId = productContainer.find(".selling_plan option:selected").val();
                if (sellingPlanId) {
                    $("#selling_plan_id").val(sellingPlanId);
                    console.log("✅ selling_plan_id gesetzt:", sellingPlanId);
                } else {
                    console.error("❌ Fehler: selling_plan_id ist leer!");
                }
            } else {
                $("#selling_plan_id").val('');
            }
        });
    }

    // Initialisiere Subscription-Optionen & Preise beim Laden
    initializeSubscriptionOptions();

    // ⬇️ erzwingt Initial-Update für ALLE Bundle-Optionen
    $('.subscription-input[value="bundle"], .subscription-input[value="bundle-new"]').each(function () {
        $(this).prop('checked', true);
        updateSubscriptionPrice();
        $(this).prop('checked', false);
    });

    // danach wieder sauberer Startzustand
    $('input[value="onetime"]').prop('checked', true);
    updateSubscriptionPrice();

    $(".subscription-loading-overlay").fadeOut(300);

    // Event-Listener für Subscription-Optionen
    $('.subscription-input, .selling_plan').on('change', function () {
        $(this).closest('.subscription-item').addClass('active').siblings().removeClass('active');

        updateCartQuantity();
        updateSellingPlanId();
        updateSubscriptionPrice();
    });

    // Aktualisiere bei Variantenwechsel
    $(document).on('variant:change', function () {
        initializeSubscriptionOptions();
        updateCartQuantity();
        updateSubscriptionPrice();
        updateSellingPlanId();
    });

    // Setzt `selling_plan_id` korrekt beim Warenkorb hinzufügen
    $("form[action='/cart/add']").on("submit", function () {
        updateCartQuantity();
        updateSellingPlanId();
        let sellingPlan = $("#selling_plan_id").val();
        console.log("🛒 Wird in den Warenkorb gesendet: selling_plan_id =", sellingPlan);
    });
});